<template>
  <!--begin::Footer-->
  <div id="kt_app_footer" class="app-footer">
    <div class="footer-inner">

      <!-- Left: Branding + Telegram -->
      <div class="footer-brand">
        <a href="https://academia.ly" target="_blank" class="footer-logo-link">
          <span class="footer-logo-icon">
            <img src="/assets/img/acad-icon.png" alt="Academia" />
          </span>
          <span class="footer-logo-text">{{ $t("common.app_name") }}</span>
        </a>
        <a href="https://t.me/aca_demia" target="_blank" class="footer-telegram">
          <i class="bi bi-telegram"></i>
          <span>0913103064</span>
        </a>
      </div>

      <!-- Center: Nav links -->
      <nav class="footer-nav">
        <a href="privacy-policy" target="_blank" class="footer-nav-link">
          <i class="bi bi-shield-check"></i>
          {{ $t("menu.privacy") }}
        </a>
        <span class="footer-nav-divider"></span>
        <a href="terms-of-service" target="_blank" class="footer-nav-link">
          <i class="bi bi-file-text"></i>
          {{ $t("menu.terms") }}
        </a>
      </nav>

      <!-- Right: Copyright -->
      <div class="footer-copy">
        <i class="bi bi-c-circle"></i>
        {{ currentYear }} &mdash; {{ $t("common.app_name") }}
      </div>

    </div>
  </div>
  <div
    dir="rtl"
    class="modal fade forgetpassword-modal"
    id="loginModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">
            {{ $t("common.login") }}
          </h5>
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">
            <i class="fa fa-close"></i> {{ $t("common.close") }}
          </button>
        </div>
        <div class="modal-body">
          <div class="card text-center p-5 not-login">
            <span class="icon"><i class="bi bi-person-badge"></i></span>
            <h3 class="mb-4">{{ $t("common.please_login_to_continue") }}</h3>
            <span>
              <a href="login" class="btn btn-success">
                {{ $t("common.login") }} <i class="fa fa-sign-in"></i>
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--end::Footer-->
  <!-- END: Footer-->
</template>

<script>
export default {
  name: "FooterComponent",
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>
/* ===== Footer Shell ===== */
.app-footer {
  background: #f8fafc;
  border-top: 1px solid #e8f0e9;
  padding: 0;
}

.footer-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 16px 24px;
}

/* ===== Brand ===== */
.footer-brand {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}

.footer-logo-link {
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  transition: opacity 0.2s;
}

.footer-logo-link:hover {
  opacity: 0.8;
}

.footer-logo-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.footer-logo-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.footer-logo-text {
  font-size: 0.9rem;
  font-weight: 700;
  color: #1e293b;
  white-space: nowrap;
}

.footer-telegram {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 20px;
  background: rgba(96, 200, 255, 0.1);
  border: 1px solid rgba(96, 200, 255, 0.3);
  color: #2a9ed6;
  font-size: 0.82rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.footer-telegram i {
  font-size: 15px;
  color: #60c8ff;
}

.footer-telegram:hover {
  background: rgba(96, 200, 255, 0.18);
  border-color: rgba(96, 200, 255, 0.55);
  color: #1a7db3;
}

/* ===== Nav ===== */
.footer-nav {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  justify-content: center;
}

.footer-nav-link {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  border-radius: 8px;
  font-size: 0.82rem;
  font-weight: 500;
  color: #64748b;
  text-decoration: none;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.footer-nav-link i {
  font-size: 13px;
}

.footer-nav-link:hover {
  background: rgba(0, 199, 68, 0.08);
  color: #00a83b;
}

.footer-nav-divider {
  display: inline-block;
  width: 1px;
  height: 14px;
  background: #cbd5e1;
  margin: 0 2px;
  border-radius: 1px;
}

/* ===== Copyright ===== */
.footer-copy {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.8rem;
  color: #94a3b8;
  font-weight: 500;
  white-space: nowrap;
}

.footer-copy i {
  font-size: 13px;
  color: #b0bec5;
}

/* ===== Modal (login prompt) ===== */
[data-bs-theme="dark"] .modal-content,
:root[data-bs-theme="dark"] .modal-content {
  background: #1e293b !important;
  border-color: rgba(255, 255, 255, 0.08) !important;
  color: #e4e6eb !important;
}

[data-bs-theme="dark"] .modal-header,
:root[data-bs-theme="dark"] .modal-header {
  background: #243044 !important;
  border-bottom-color: #334155 !important;
}

[data-bs-theme="dark"] .modal-title,
:root[data-bs-theme="dark"] .modal-title {
  color: #f1f5f9 !important;
}

[data-bs-theme="dark"] .modal-body,
:root[data-bs-theme="dark"] .modal-body {
  background: #1e293b !important;
  color: #e4e6eb !important;
}

[data-bs-theme="dark"] .modal-body .card,
:root[data-bs-theme="dark"] .modal-body .card {
  background: #243044 !important;
}

[data-bs-theme="dark"] .modal-body h3,
:root[data-bs-theme="dark"] .modal-body h3 {
  color: #f1f5f9 !important;
}

/* ===== DARK MODE ===== */
:root[data-bs-theme="dark"] .app-footer {
  background: #1a1b1d;
  border-top-color: rgba(255, 255, 255, 0.07);
}

:root[data-bs-theme="dark"] .footer-logo-text {
  color: #e4e6eb;
}

:root[data-bs-theme="dark"] .footer-telegram {
  background: rgba(96, 200, 255, 0.08);
  border-color: rgba(96, 200, 255, 0.2);
  color: #7dd3f5;
}

:root[data-bs-theme="dark"] .footer-telegram:hover {
  background: rgba(96, 200, 255, 0.15);
  border-color: rgba(96, 200, 255, 0.4);
  color: #a8e0f7;
}

:root[data-bs-theme="dark"] .footer-nav-link {
  color: #94a3b8;
}

:root[data-bs-theme="dark"] .footer-nav-link:hover {
  background: rgba(0, 199, 68, 0.08);
  color: #4ade80;
}

:root[data-bs-theme="dark"] .footer-nav-divider {
  background: #334155;
}

:root[data-bs-theme="dark"] .footer-copy {
  color: #64748b;
}

/* ===== Responsive ===== */
@media (max-width: 768px) {
  .footer-inner {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 12px;
    padding: 16px;
  }

  .footer-nav {
    order: 2;
  }

  .footer-copy {
    order: 3;
  }
}
</style>
